<div class="overview-container flex gap-spacing-xl">
  <div
    class="chart-card flex flex-column radius-xl statistics-card-success-bg gap-spacing-xl p-spacing-xl"
  >
    <div class="card-header flex justify-content-between">
      <span class="body-medium-bold text-secondary-color">Milles Driven</span>
      <span class="body-medium-regular text-light-color">Every Minute</span>
    </div>
    <div class="border-left-1 border-neutral-muted-l3-color splitter"></div>
    <div class="chart-container">
      <div class="chart-content-wrapper">
        <app-line-chart (dataBound)="onDataBound($event)"></app-line-chart>
      </div>
    </div>
  </div>

  <div
    class="chart-card flex flex-column radius-xl statistics-card-success-bg gap-spacing-xl p-spacing-xl"
  >
    <div class="card-header flex justify-content-between">
      <span class="body-medium-bold text-secondary-color"
        >Events Statistics</span
      >
      <span class="body-medium-regular text-light-color">Last 7 days</span>
    </div>
    <div class="border-left-1 border-neutral-muted-l3-color splitter"></div>
    <div class="chart-container">
      <div class="chart-content-wrapper">
        <app-bar-stack-normalization-chart></app-bar-stack-normalization-chart>
      </div>
    </div>
  </div>
</div>
